module.exports = __webpack_public_path__ + "static/space.ysxq-f6fd5fac1882338a8cac72fec56a8e26.png";